export const mediaQuery = `
  @media only screen and (max-width: 480px) {
    #ual-box {
      width: 100% !important;
      height: 100% !important;
      box-shadow: none !important;
      transform: none !important;
      margin: 0 !important;
      border-radius: 0px !important;
    }
  }
`
